module.exports = __webpack_public_path__ + "img/inico_prospectos.c928e647.png";